import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import { FC } from 'react'

import LearnMoreTiles from '@/components/LearnMoreTiles'
import useDevice from '@/hooks/useDevice'

const OurValues: FC = () => {
    const { smScreen } = useDevice()

    return (
        <Box>
            <Text
                variant={smScreen ? 'h5' : 'h4'}
                sx={{
                    textAlign: smScreen ? `start` : `center`,
                    mb: 9,
                }}
            >
                Our values
            </Text>
            <LearnMoreTiles
                tiles={[
                    {
                        title: 'Force for good',
                        description: 'Raise the bar for our people, our customers, our planet.',
                        icon: '/icons/icon-high-quality-peace-1.png',
                    },
                    {
                        title: 'Lead with innovation',
                        description: 'Challenge the status quo.',
                        icon: '/icons/icon-lead-innovation.png',
                    },
                    {
                        title: 'Open and honest',
                        description: 'Speak our minds with care, communicate openly and candidly.',
                        icon: '/icons/icon-open-honest.png',
                    },
                    {
                        title: 'Guided by curiosity',
                        description:
                            'Think beyond boundaries, allow yourself the freedom to learn and grow.',
                        icon: '/icons/icon-curiosity.png',
                    },
                ]}
            />
        </Box>
    )
}

export default OurValues
